export function normalizeBusinessContextCompanyURL (raw) {
    const trimmed = (raw || '').trim();

    if (!trimmed) {
        return '';
    }

    if (/^https?:\/\//i.test(trimmed)) {
        return trimmed;
    }

    return `https://${trimmed}`;
}

export function asCompetitorsString (value) {
    if (value == null) {
        return '';
    }

    if (Array.isArray(value)) {
        return value.map(String).filter(Boolean).join(',');
    }

    return String(value);
}

function hasUsableGenerateContent (fields) {
    const t = (v) => String(v ?? '').trim();

    return t(fields.name) !== '' || t(fields.description) !== '';
}

export function isGenerateBusinessContextResultEmpty (fields) {
    return !hasUsableGenerateContent(fields);
}

export function mergeGenerateBusinessContextWithPrevious (prev, result) {
    const nonempty = (v) => v != null && String(v).trim() !== '';

    return {
        name: String(prev?.name ?? ''),
        description: nonempty(result.description) ? String(result.description).trim() : String(prev?.description ?? ''),
        competitors: nonempty(result.competitors) ? asCompetitorsString(result.competitors) : String(prev?.competitors ?? ''),
        domain: nonempty(result.domain) ? String(result.domain).trim() : String(prev?.domain ?? ''),
    };
}
